/* Cammarata Mode: Klarna informational dialog stays over the product. */
(function () {
  'use strict';
  if (window.__cmKlarnaInfoDialogBound) return;
  window.__cmKlarnaInfoDialogBound = true;
  var openers = new WeakMap();
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var trigger = target.closest('[data-cm-klarna-open]');
    if (trigger) {
      var wrapper = trigger.closest('.cm-klarna-pdp');
      var dialogId = trigger.getAttribute('aria-controls');
      var dialog = dialogId ? document.getElementById(dialogId) : null;
      if (!wrapper || !dialog || !dialog.matches('dialog.cm-klarna-info-dialog')) return;
      event.preventDefault();
      openers.set(dialog, trigger);
      if (!dialog.open && typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
      var returnButton = dialog.querySelector('[data-cm-klarna-close]');
      if (returnButton) returnButton.focus();
      return;
    }
    var closer = target.closest('[data-cm-klarna-close]');
    if (closer) {
      var current = closer.closest('dialog.cm-klarna-info-dialog');
      if (!current) return;
      event.preventDefault();
      current.close();
      return;
    }
    var clickedDialog = target.closest('dialog.cm-klarna-info-dialog');
    if (clickedDialog && target === clickedDialog && clickedDialog.open) {
      var rect = clickedDialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right ||
          event.clientY < rect.top || event.clientY > rect.bottom) {
        clickedDialog.close();
      }
    }
  });
  document.addEventListener('close', function (event) {
    var dialog = event.target;
    if (!(dialog instanceof Element) || !dialog.matches('dialog.cm-klarna-info-dialog')) return;
    var opener = openers.get(dialog);
    if (opener && opener.isConnected) opener.focus();
    openers.delete(dialog);
  }, true);
})();
